import React from "react"

import { Select } from "antd"

const SelectBox = ({ options, showSearch, keyPrefix, ...props }) => {
  return (
    <Select
      {...props}
      showSearch={showSearch}
      optionFilterProp="label"
      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
      style={{ width: "100%" }}
      options={options.map((o, i) => ({ label: o.label, value: o.value, key: `${i}-${keyPrefix}${o.value}` }))}
    />
  )
}

export default SelectBox
